import {
  Arrange,
  Button,
  Container,
  Spacer,
  Text,
  TextInput,
} from '@loomhq/lens';
import React from 'react';

import {
  ANON_NAV_LOGIN_PAGE_CLICKED,
  ANON_NAV_SIGNUP_PAGE_CLICKED,
} from 'constants/events';
import { EXP_ANON_SIDENAV_EMAIL_INPUT } from 'constants/featureFlag';
import { SIGNUP_PAGE } from 'constants/routes';
import { track } from 'utilities/analytics';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import SigninButton from 'components/signin-button';
import SignupButton from 'components/signup-button';

export default function SignupCallout() {
  const showEmailInput = useFeatureFlagValue(EXP_ANON_SIDENAV_EMAIL_INPUT);
  const [email, setEmail] = React.useState('');

  const onSubmit = e => {
    e.preventDefault();
    track(ANON_NAV_SIGNUP_PAGE_CLICKED, {
      from_url: window.location.href,
      source: 'anon-nav',
      has_email_input: showEmailInput,
    });
    window.open(`${SIGNUP_PAGE}?invitee_email=${encodeURIComponent(email)}`);
  };

  return (
    <Container
      backgroundColor="background"
      borderSide="all"
      padding="medium"
      radius="medium"
    >
      <Text color="body" fontWeight="medium">
        Skip the meeting and record a quick video instead.
      </Text>
      {showEmailInput !== undefined && (
        <>
          <Spacer top="small" />
          {showEmailInput ? (
            <form onSubmit={onSubmit}>
              <Arrange autoFlow="row" gap="small" justifyContent="stretch">
                <label htmlFor="email" className="srOnly">
                  Email address
                </label>
                <TextInput
                  placeholder="Email address"
                  size="small"
                  id="email"
                  onChange={e => setEmail(e.target.value)}
                />
                <Button type="submit" size="small" variant="primary">
                  Get Loom for Free
                </Button>
              </Arrange>
            </form>
          ) : (
            <Arrange gap="small">
              <SigninButton
                size="small"
                tracking={{
                  eventName: ANON_NAV_LOGIN_PAGE_CLICKED,
                  properties: {
                    from_url: window.location.href,
                    source: 'anon-nav',
                  },
                }}
              />
              <SignupButton
                size="small"
                tracking={{
                  eventName: ANON_NAV_SIGNUP_PAGE_CLICKED,
                  properties: {
                    from_url: window.location.href,
                    source: 'anon-nav',
                    has_email_input: showEmailInput,
                  },
                }}
              />
            </Arrange>
          )}
        </>
      )}
    </Container>
  );
}
